/**
 * Extract base domain from email address, excluding subdomains.
 * e.g., "user@foo.bar.edu" → "bar.edu", "user@example.com" → "example.com"
 */
export function getEmailBaseDomain(email?: string): string | undefined {
  if (!email) return undefined;
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return undefined;

  const domain = email.substring(atIndex + 1).toLowerCase();
  const parts = domain.split('.');

  // Return last 2 parts for standard TLDs (e.g., bar.edu, example.com)
  if (parts.length >= 2) {
    return parts.slice(-2).join('.');
  }
  return domain;
}
